import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { LottieOptions } from 'ngx-lottie/lib/symbols';

@NgModule()
export class LottieConfigModule {
  static withOptions(options: LottieOptions): ModuleWithProviders<LottieConfigModule> {
    return {
      ngModule: LottieConfigModule,
      providers: [provideCacheableAnimationLoader(), provideLottieOptions(options)]
    };
  }
}
